export default function fromIframe(target, { targetOrigin = '*' } = {}) {
    if (typeof window === 'undefined') {
        throw new Error(`You can only run fromIframe() in a browser context, but no window was found.`);
    }
    const listenerMap = new WeakMap();
    return {
        postMessage (message, transfer) {
            var _target_contentWindow;
            (_target_contentWindow = target.contentWindow) === null || _target_contentWindow === void 0 ? void 0 : _target_contentWindow.postMessage(message, targetOrigin, transfer);
        },
        addEventListener (event, listener) {
            const wrappedListener = (event)=>{
                if (event.source !== target.contentWindow) {
                    return;
                }
                listener(event);
            };
            listenerMap.set(listener, wrappedListener);
            self.addEventListener(event, wrappedListener);
        },
        removeEventListener (event, listener) {
            const wrappedListener = listenerMap.get(listener);
            if (wrappedListener == null) {
                return;
            }
            listenerMap.delete(listener);
            self.removeEventListener(event, wrappedListener);
        }
    };
}

//# sourceMappingURL=fromIframe.js.map